export default __webpack_public_path__ + "static/macbook-04da1434f80141f21491b06a1c8eff1e.png";